/**
 * Regular Expressions to validate string patters
 * Names should have only alphabets and spaces in between
 * EmailID should be in valid email format
 */
const nameRegex = /^[a-z ]*[a-z]$/i;
const emailRegex =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const phoneRegex = /^[0-9]{10}$/;

export const validEmail = (emailId) => {
  return emailId && emailRegex.test(String(emailId));
};

export const validName = (name) => {
  return name && nameRegex.test(String(name));
};

export const isValidPhoneNumber = (phone) => phoneRegex.test(phone);
